
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/screenshots",
      function () {
        return require("private-next-pages/screenshots.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/screenshots"])
      });
    }
  